"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.select = exports.setSelection = exports.moveSelection = exports.drawAll = exports.close = exports.open = exports.isOpen = exports.get = void 0;
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueHotkeys_sidecar_1 = require("../monofont/rogueHotkeys-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueRunner_sidecar_1 = require("../scene/rogueRunner-sidecar");
var rogueTester_7drl_2023_sidecar_1 = require("../scene/rogueTester_7drl_2023-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            items: [],
            isOpen: false,
            highlighted: 0,
            isResetGameMode: false,
        };
        // _obj.items.push({
        //   name: `Fire 1`,
        //   letter: '1',
        //   action: () => {
        //     //rogueCursor.setTargetMode(ERogueTargetMode.waterbolt)
        //     rogueRunner.nextLevel()
        //   },
        // })
        // _obj.items.push({
        //   name: `Fire 2`,
        //   letter: '2',
        //   action: () => {
        //     rogueRunner.nextLevel()
        //   },
        // })
    }
    return _obj;
};
exports.get = get;
var isOpen = function () {
    return (0, exports.get)().isOpen;
};
exports.isOpen = isOpen;
var open = function (isResetGameMode) {
    if (isResetGameMode === void 0) { isResetGameMode = false; }
    var obj = (0, exports.get)();
    obj.isOpen = true;
    obj.isResetGameMode = isResetGameMode;
    obj.items = [];
    var options = rogueTester_7drl_2023_sidecar_1.rogueTester_7drl_2023.getNextLevels();
    if (obj.isResetGameMode) {
        options = rogueTester_7drl_2023_sidecar_1.rogueTester_7drl_2023.genNextLevels(1);
    }
    var idx = 0;
    options.forEach(function (c) {
        idx++;
        obj.items.push({
            name: "".concat(c.housePrototype.houseSizeName, " House - ").concat(c.housePrototype.difficulty.difficultyName, " Fire"),
            letter: '' + idx,
            action: function () {
                //rogueRunner.nextLevel()
                if (obj.isResetGameMode) {
                    rogueTester_7drl_2023_sidecar_1.rogueTester_7drl_2023.resetGame(c.difficultyGen(), c.houseGen);
                }
                else {
                    rogueRunner_sidecar_1.rogueRunner.nextLevel(c);
                }
            },
        });
    });
};
exports.open = open;
var close = function () {
    var obj = (0, exports.get)();
    obj.isOpen = false;
    rogueHotkeys_sidecar_1.rogueHotkeys.clearAll();
};
exports.close = close;
var drawAll = function () {
    var obj = (0, exports.get)();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    (0, exports.moveSelection)(0, 0); // Reset wrap
    if (obj.isResetGameMode) {
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Select starting fire to Reset Game', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
    }
    else {
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Select Fire to Fight', rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.darkBlue);
    }
    var _loop_1 = function (i) {
        var item = obj.items[i];
        y++;
        var isHighlighted = i === obj.highlighted;
        rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (isHighlighted ? '>' : ' ') + item.letter + ':' + item.name, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () {
            (0, exports.setSelection)(i);
            (0, exports.select)();
        }, function () {
            (0, exports.setSelection)(i);
        }, item.letter);
    };
    // y++
    for (var i = 0; i < obj.items.length; i++) {
        _loop_1(i);
    }
};
exports.drawAll = drawAll;
var moveSelection = function (oy, ox) {
    var obj = (0, exports.get)();
    (0, exports.setSelection)(obj.highlighted + oy);
};
exports.moveSelection = moveSelection;
var setSelection = function (selIdx) {
    var obj = (0, exports.get)();
    obj.highlighted = selIdx;
    // Wrap
    obj.highlighted = mathUtils_sidecar_1.mathUtils.betterMod(obj.highlighted, obj.items.length);
};
exports.setSelection = setSelection;
var select = function () {
    var obj = (0, exports.get)();
    var item = obj.items[obj.highlighted];
    if (item.action) {
        item.action();
    }
    if (item.command) {
        rogueInput_sidecar_1.rogueInput.setNextInputCommand(item.command);
    }
    (0, exports.close)();
};
exports.select = select;
var cancel = function () {
    (0, exports.close)();
};
exports.cancel = cancel;
